import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';

import { AuthenticationService } from '@services/authentication.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';
import { isPlatformBrowser } from '@angular/common';
import { SiteService } from '@app/_services';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
        @Inject(PLATFORM_ID) private platformId: any
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        const currentUser = this.authenticationService.currentUserValue;
        if (currentUser) {
            return true;
        } else if (isPlatformBrowser(this.platformId)) {
            return this.authenticationService.getUserDetails().pipe(map((user: any): any => {
                if (!_.isEmpty(user.data)) {
                    return true;
                }
                this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
                return false;
            }))
        } else {
            return false;
        }

    }
}

@Injectable({ providedIn: 'root' })
export class LoggedInAuthGuard {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
        private route: ActivatedRoute,
        private siteService: SiteService,
        @Inject(PLATFORM_ID) private platformId: any

    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {

        const currentUser = this.authenticationService.currentUserValue;
        if (currentUser) {
            if (this.siteService?.siteSetting?.loggedInOnly) {
                this.router.navigate(['/en']);
            } else {
                this.router.navigate(['../'], { relativeTo: this.route });
            }
            return false;
        } else if (isPlatformBrowser(this.platformId)) {
            return this.authenticationService.getUserDetails().pipe(map((user: any): any => {
                if (user?.data?.email) {
                    if (this.siteService?.siteSetting?.loggedInOnly) {
                        this.router.navigate(['/en']);
                    } else {
                        this.router.navigate(['../'], { relativeTo: this.route });
                    }
                    return false;
                }
                return true;
            }))
        } else {
            return false;
        }
    }
}
